import styled from 'styled-components'

export const StyledContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	${/* Recompense bottom margin of items in the last row */''}
	margin-bottom: -14px;
`
export const StyledCol = styled.div`
	flex-basis: 140px;
	margin-bottom: 14px;
	&:not(:last-of-type) {
		margin-right: 30px;
	}
	p, label {
		font-weight: normal;
	}
`
export const Dot = styled.div`
	width: 3px;
	height: 3px;
	border-radius: 50%;
	background: ${({ color }) => color};
`
export const Tooltip = styled.div`
	display: flex;
	align-items: center;
	span {
		margin-left: 10px;
	}
`
